import React from 'react';
import { isUndefined } from '../../../../lib/typeCheck';
import { Table, Thead, Tbody, Row, HeadingCell, Cell } from './StyledTable';
import { formatReadableTimebaseFromSeconds } from '../../../../lib/time';

const formatNoiseLevelNow = (limit) => {
  if (isUndefined(limit.last_value)) return '';
  if (limit.type === 'lmax') return limit.last_value.max.toFixed(1);
  if (limit.type === 'leq') return limit.last_value.cleq.toFixed(1);
}

const formatNoiseErl = (limit) => {
  if (isUndefined(limit.last_value)) return '';
  if (limit.type === 'lmax') return '-';
  if (limit.type === 'leq') return limit.last_value.erl.toFixed(1);
}

export const NoiseLimitTable = ({ limits }: { limits: any }) => {
  return (
    <Table>
      <Thead>
        <Row>
          <HeadingCell>Position</HeadingCell>
          <HeadingCell>Type</HeadingCell>
          <HeadingCell>Timebase</HeadingCell>
          <HeadingCell>Limit</HeadingCell>
          <HeadingCell>Level Now</HeadingCell>
          <HeadingCell>ERL</HeadingCell>
          <HeadingCell centered={true}>Exceedances</HeadingCell>
        </Row>
      </Thead>
      <Tbody>
        {limits.map((limit, index) => (
          <Row>
            <Cell>{index === 0? 'Primary Limit' : 'Limit ' + (index + 1)}</Cell>
            <Cell>{limit.type}</Cell>
            <Cell>{formatReadableTimebaseFromSeconds(limit.timebase)}</Cell>
            <Cell>{limit.threshold}</Cell>
            <Cell>{formatNoiseLevelNow(limit)}</Cell>
            <Cell>{formatNoiseErl(limit)}</Cell>
            <Cell centered={true}>{limit.total_exceedances}</Cell>
          </Row>
        ))}
      </Tbody>
    </Table>
  )
}

